import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { backendApi } from "@/utils/URL";
import { Button } from "@/components/Button";

interface VersionData {
    php: string;
    laravel: string;
    mariadb: string | null;
    mysql: string | null;
}

export const Versions: React.FC = () => {
    const navigate = useNavigate();
    const [data, setData] = useState<VersionData | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchVersions = async () => {
            try {
                const base = backendApi() || "http://localhost:8000/api";
                const res = await fetch(`${base}/versions?json=1`, {
                    headers: { Accept: "application/json" },
                });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const json = await res.json();
                setData(json);
            } catch (err: any) {
                setError(err.message || "Error cargando versiones");
            } finally {
                setLoading(false);
            }
        };

        fetchVersions();
    }, []);

    return (
        <div className="flex min-h-screen items-center justify-center bg-black p-6">
            <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl dark:bg-zinc-900">
                <div className="mb-6 flex justify-center">
                    <img
                        src="/images/logo.png"
                        alt="Logo"
                        className="h-10 object-contain"
                        onError={(e) => {
                            (e.target as HTMLImageElement).src = "/logo.png";
                        }}
                    />
                </div>

                <h1 className="mb-4 text-center text-xl font-bold text-zinc-900 dark:text-white">
                    Versiones del Sistema
                </h1>

                {loading ? (
                    <div className="py-8 text-center text-sm text-zinc-500">
                        Cargando versiones...
                    </div>
                ) : error ? (
                    <div className="py-4 text-center text-sm text-red-500">
                        No se pudieron cargar las versiones: {error}
                    </div>
                ) : (
                    <div className="space-y-3 rounded-lg bg-zinc-50 p-4 text-sm text-zinc-700 dark:bg-zinc-800 dark:text-zinc-200">
                        <div className="flex justify-between border-b border-zinc-200 pb-2 dark:border-zinc-700">
                            <span className="font-medium text-zinc-500 dark:text-zinc-400">
                                PHP
                            </span>
                            <span className="font-semibold">{data?.php}</span>
                        </div>
                        <div className="flex justify-between border-b border-zinc-200 pb-2 dark:border-zinc-700">
                            <span className="font-medium text-zinc-500 dark:text-zinc-400">
                                Laravel
                            </span>
                            <span className="font-semibold">
                                {data?.laravel}
                            </span>
                        </div>
                        {data?.mariadb && (
                            <div className="flex justify-between border-b border-zinc-200 pb-2 dark:border-zinc-700">
                                <span className="font-medium text-zinc-500 dark:text-zinc-400">
                                    MariaDB
                                </span>
                                <span className="font-semibold">
                                    {data?.mariadb}
                                </span>
                            </div>
                        )}
                        {data?.mysql && (
                            <div className="flex justify-between border-b border-zinc-200 pb-2 dark:border-zinc-700">
                                <span className="font-medium text-zinc-500 dark:text-zinc-400">
                                    MySQL
                                </span>
                                <span className="font-semibold">
                                    {data?.mysql}
                                </span>
                            </div>
                        )}
                    </div>
                )}

                <div className="mt-6 flex justify-center">
                    <Button variant="secondary" onClick={() => navigate(-1)}>
                        Volver
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Versions;
